import { NgModule } from '@angular/core';

import { SPECIAL_HTTP_ERROR_HANDLER } from './interceptors/icm-error-mapper.interceptor';
import { createPaymentErrorHandler } from './utils/http-error/create-payment.error-handler';
import { dataRequestErrorHandler } from './utils/http-error/data-request.error-handler';
import { editPasswordErrorHandler } from './utils/http-error/edit-password.error-handler';
import { LoginUserErrorHandler } from './utils/http-error/login-user.error-handler';
import { MfaErrorHandler } from './utils/http-error/mfa.error-handler';
import { requestReminderErrorHandler } from './utils/http-error/request-reminder.error-handler';
import { updateOciConfigurationErrorHandler } from './utils/http-error/update-oci-configuration.error-handler';
import { updatePasswordErrorHandler } from './utils/http-error/update-password.error-handler';

@NgModule({
  providers: [
    // DIAS Customization Start - Email OTP MFA for ICM local login
    // must be registered before LoginUserErrorHandler: that handler matches any 401/403 on the token
    // endpoint and would otherwise swallow the MFA challenge/error body first
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useClass: MfaErrorHandler, multi: true },
    // DIAS Customization End
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useClass: LoginUserErrorHandler, multi: true },
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useValue: requestReminderErrorHandler, multi: true },
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useValue: dataRequestErrorHandler, multi: true },
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useValue: editPasswordErrorHandler, multi: true },
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useValue: createPaymentErrorHandler, multi: true },
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useValue: updatePasswordErrorHandler, multi: true },
    { provide: SPECIAL_HTTP_ERROR_HANDLER, useValue: updateOciConfigurationErrorHandler, multi: true },
  ],
})
export class ConfigurationModule {}
